const globalEnum = {
    resourceType: {
        'root': 0,
        'directory': 1,
        'menu': 2,
        'action': 3,
        'tab': 4,
        'group': 5
    },

    yesOrNo: {
        'Yes': 1,
        'No': 0
    },

    actStatus: {
        "null": 0,
        "before": 1,
        "on": 2,
        "after": 3
    },
    sex: {
        "Male": 1,
        "Female": 0
    },
    VIEW_TYPE: {
        "NOTICE": [1, "公告", ],
        "ACT": [2, "活动", ],
        "PROJECT": [3, "项目", ],
    },
}

export default globalEnum